<script setup>
import icons from '~/utils/inline-icons.json';

const props = defineProps({ name: { type: String, required: true }, title: String, desc: String, viewBox: String });
const icon = computed(() => icons[props.name.toLowerCase().replace(/\.svg$/, '').replace(/:/g, '--')]);
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icons" width="1em" height="1em"
    v-bind="icon?.attrs" :viewBox="viewBox || icon?.attrs.viewBox" focusable="false"
    :aria-hidden="title ? undefined : true" :role="title ? 'img' : undefined">
    <title v-if="title">{{ title }}</title>
    <desc v-if="desc">{{ desc }}</desc>
    <!-- Body is generated exclusively from the checked-in, sanitized SVG assets. -->
    <g v-if="icon" v-html="icon.body" />
  </svg>
</template>
